<app-system-notification [visible]="showGracePeriodWarning" [title]="'Grace Period' | translate" [message]="'Your Multilingual addon has expired. You have ' + gracePeriodInfo?.daysRemaining + ' days left to renew before multilingual features are disabled.'" actionLabel="Renew Subscription" (action)="router.navigate(['/billing'])">
</app-system-notification>

<mat-progress-bar mode="indeterminate" *ngIf="productProgress" class="genie-progress-bar"></mat-progress-bar>

<div class="genie-page">
  <!-- Back Button -->

  <!-- Page Header -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <p class="genie-page-title">{{ 'Languages' | translate }}</p>
      <p class="genie-page-subtitle">{{ 'Manage the languages available in your system.' | translate }}</p>
    </div>
    <div class="header-right">
      <div class="add-language-dropdown" (click)="$event.stopPropagation()">
        <button class="genie-btn primary" (click)="toggleDropdown($event)">+ {{ 'Add Language' | translate }}</button>
        <div class="dropdown-panel" *ngIf="dropdownOpen">
          <div class="dropdown-search">
            <input type="text" [(ngModel)]="dropdownSearch" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Search...' | translate }}" (click)="$event.stopPropagation()" />
          </div>
          <div class="dropdown-options">
            <div class="dropdown-option" *ngFor="let lang of filteredLanguageCodes" [class.selected]="isLanguageInTable(lang)" (click)="selectLanguage(lang, $event)">
              {{ lang | translate }}
            </div>
          </div>
        </div>
      </div>
      <button class="btn-save" (click)="onSubmit()">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>

  <!-- Translate Numbers Card -->
  <div class="translate-numbers-card">
    <div class="translate-numbers-row">
      <div class="translate-numbers-info">
        <span class="translate-title">{{ 'Translate Numbers' | translate }}</span>
        <span class="translate-desc">{{ 'Automatically translate numbers based on selected language' | translate }}</span>
      </div>
      <label class="toggle-switch">
        <input type="checkbox" [(ngModel)]="translateNumbers" [ngModelOptions]="{ standalone: true }" />
        <span class="toggle-slider"></span>
      </label>
    </div>
  </div>

  <!-- Languages Table -->
  <div class="genie-table-wrapper">
    <table class="genie-table">
      <thead>
        <tr>
          <th>{{ 'Languages' | translate }}</th>
          <th class="col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lang of pagedLanguages">
          <td>{{ lang.title }}</td>
          <td class="col-actions">
            <div class="genie-action-buttons" *ngIf="language.length > 1">
              <button
                class="genie-default-btn"
                (click)="selectDefaultLanguage(lang.title)"
                [ngClass]="{
                  selected: defaultLanguage === lang.title,
                  'not-selected': defaultLanguage !== lang.title
                }"
                [disabled]="defaultLanguage === lang.title"
              >
                {{ defaultLanguage === lang.title ? ('Default' | translate) : ('Set as default' | translate) }}
              </button>
              <button class="genie-icon-btn delete" (click)="deleteRow(lang.title)">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438"
                    stroke="currentColor"
                    stroke-width="1.467"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="genie-pagination" *ngIf="totalPages > 1">
      <div class="pagination-info">
        <span class="current-page">{{ currentPage }}</span>
        <span class="page-separator">of</span>
        <span class="total-pages">{{ totalPages }}</span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn" (click)="prevPage()" [disabled]="currentPage === 1">
          <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 1L1 4L4 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button class="page-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
          <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L4 4L1 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="multilingual" id="multilingual" (ngSubmit)="onSubmit()"></form>
